import { taggedTemplateLiteral as _taggedTemplateLiteral, objectWithoutProperties as _objectWithoutProperties } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';
import React, { memo } from 'react';
import DateSelectContainer from '../DateSelect/DateSelectContainer.js';
import { InputContainer } from '../InputContainer/index.js';
import SelectRelativeContainer from '../SelectInput/SelectRelativeContainer.js';

var _excluded = ["language", "optional", "children"];
var _templateObject, _templateObject2;
var StyledLabel = styled('label')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  font-weight: bold;\n  font-size: 1em;\n  opacity: ", ";\n  height: ", ";\n\n  &\n    + ", ",\n    &\n    + ", ",\n    &\n    + ", " {\n    margin-top: ", ";\n  }\n"])), function (_ref) {
  var disabled = _ref.disabled,
    hidden = _ref.hidden;
  if (hidden) {
    return 0;
  }
  return disabled ? 0.3 : 1;
}, function (_ref2) {
  var hidden = _ref2.hidden;
  return hidden ? 0 : undefined;
}, InputContainer, SelectRelativeContainer, DateSelectContainer, function (_ref3) {
  var hidden = _ref3.hidden;
  return !hidden ? '10px' : undefined;
});
var StyledOptionalTag = styled('span')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-size: 0.875rem;\n  font-weight: normal;\n  margin-left: 5px;\n"])));
var Label = function Label(_ref4) {
  var _ref4$language = _ref4.language,
    language = _ref4$language === void 0 ? 'en' : _ref4$language,
    _ref4$optional = _ref4.optional,
    optional = _ref4$optional === void 0 ? false : _ref4$optional,
    children = _ref4.children,
    rest = _objectWithoutProperties(_ref4, _excluded);
  return /*#__PURE__*/React.createElement(StyledLabel, rest, children, optional && /*#__PURE__*/React.createElement(StyledOptionalTag, null, "(", language === 'en' ? 'optional' : 'opcional', ")"));
};
var _Label = /*#__PURE__*/memo(Label);

export default _Label;
export { StyledOptionalTag };
